import TransferItem from '../models/transfer-item';

/**
 * Item types supported by VRL
 * @type {Object}
 */
export const itemTypes: Record<string, string[]> = {
  image: ['JPG', 'JPEG', 'PNG', 'PSD', 'TIF', 'TIFF'],
  audio: ['MP3', 'WAV'],
};

export const itemHeight = {
  image(
    nodeDimensions: { width: number },
    { height = 400, width = 400 } = {}
  ): number {
    if (!nodeDimensions) {
      return 0;
    }

    const ratio = height / width;

    return Math.round(nodeDimensions.width * ratio);
  },
  audio(): number {
    return 100;
  },
};

export const getItemType = (item: TransferItem): string => {
  let itemType = '';

  Object.keys(itemTypes).some((type) => {
    if (itemTypes[type].includes(item.type.toUpperCase())) {
      itemType = type;

      return true;
    }

    return false;
  });

  return itemType;
};

// Grid is displayed when transfer consists of at least 2 items
// One of those items must be previewable
export const canBeShownAsGrid = (items: TransferItem[] = []): boolean =>
  items.length > 1 && items.some(({ previewable }) => previewable);

export const isPreviewable = ({
  items,
  password_protected,
}: {
  items: { file: TransferItem }[];
  password_protected: boolean;
}): boolean => {
  if (password_protected) return false;

  return items.some(({ file: { type } }) => {
    return itemTypes.image.includes(type) || itemTypes.audio.includes(type);
  });
};
